<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Documentos por cobrar
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Cuenta corriente</span>
      <span> /</span>
      <span>Documentos por cobrar</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col d-flex flex-column" style="max-width: 150px;">
          <!-- Material checked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaResumen" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_RESUMEN" />
            <label class="form-check-label" for="rbVistaResumen">Resumen</label>
          </div>
          <!-- Material unchecked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaDetalle" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_DETALLE" />
            <label class="form-check-label" for="rbVistaDetalle">Detalle</label>
          </div>
        </div>
        <div class="col" style="max-width: 150px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaDesde"></mdb-date-picker>
            <div *ngIf="
                                          formHeader.get('fechaDesde').invalid &&
                                          (formHeader.get('fechaDesde').dirty ||
                                          formHeader.get('fechaDesde').touched)
                                        ">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha desde
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 150px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required
              formControlName="fechaHasta"></mdb-date-picker>
            <div *ngIf="
                                          formHeader.get('fechaHasta').invalid &&
                                          (formHeader.get('fechaHasta').dirty ||
                                          formHeader.get('fechaHasta').touched)
                                        ">
              <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha hasta
              </mdb-error>
            </div>
          </div>
        </div>
        <div [ngClass]="{'col': true, disabledContent: !enableClienteInputs}" style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="text" id="rutcliente" class="form-control" placeholder="" #rutcliente
              formControlName="rutCliente" formatRut />
            <label for="rutcliente">RUT cliente</label>
            <!-- <div *ngIf="
                                            formHeader.get('rutCliente').invalid &&
                                            (formHeader.get('rutCliente').dirty ||
                                            formHeader.get('rutCliente').touched)
                                          ">
                                            <mdb-error *ngIf="formHeader.get('rutCliente').hasError('required')">Ingrese cliente
                                            </mdb-error>
                                        </div> -->
          </div>
        </div>
        <div [ngClass]="{'col d-flex': true, disabledContent: !enableClienteInputs}" style="max-width: 20%;">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="abrirModalSeleccionarCliente()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;" *ngIf="clienteSeleccionado">
            {{ clienteSeleccionado.razon_social }}
          </h6>
        </div>
        <div class="col" style="max-width: 15%;">
          <mdb-checkbox formControlName="agregarFaltantes" [checked]="false">Faltantes Transportista</mdb-checkbox>
        </div>
        <div class="col" style="max-width: 3%;">
          <mdb-checkbox formControlName="todosClientes" [checked]="true" hidden>Todos</mdb-checkbox>
        </div>
        <!--
                <div [ngClass]="{'col': true, disabledContent: !enableVendedorInputs}" style="max-width: 150px;">
                    <div class="md-form">
                        <input value="" type="text" id="rutvende" class="form-control" placeholder="" #rutvende
                            formControlName="rutVendedor" formatRut />
                        <label for="rutvende" >RUT vendedor</label>

                    </div>
                </div>
                <div [ngClass]="{'col d-flex': true, disabledContent: !enableVendedorInputs}" style="max-width: 300px;">
                    <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                        (click)="abrirModalSeleccionarVendedor()">
                        <mdb-icon fas icon="search"></mdb-icon>
                    </button>
                    <h6 class="text-info" style="display: contents;">
                        {{ vendedorSeleccionado?.nombre }}
                    </h6>
                </div>
                <div class="col" style="max-width: 150px;">
                    <mdb-checkbox formControlName="todosVendedores" [checked]="true" hidden>Todos</mdb-checkbox>
                </div> -->

        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsVendedores" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar vendedores" formControlName="vendedores">
            </mdb-select>
            <label>Vendedores</label>
            <div *ngIf="
                              formHeader.get('vendedores').invalid &&
                              (formHeader.get('vendedores').dirty ||
                              formHeader.get('vendedores').touched)
                          ">
              <mdb-error *ngIf="formHeader.get('vendedores').hasError('required')">
                Ingrese vendedores
              </mdb-error>
            </div>
          </div>
        </div>
      </div>


    </div>
    <!-- FOOTER -->
    <div class="card-body d-sm-flex justify-content-end" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="abrirModalSeleccionDocumento()">
        <mdb-icon fas icon="balance-scale"></mdb-icon>
        Ajuste de Cte.Cta.
      </button>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="limpiarfiltros()">
        <mdb-icon fas icon="broom"></mdb-icon>
        Limpiar
      </button>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <!-- INICIO RESUMEN -->
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="resumen_listaMovimientos"
        id="DocxCobrar">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">RUT</th>
            <th scope="col">Nombre</th>
            <th scope="col">Dirección</th>
            <th scope="col">Comuna</th>
            <th scope="col">Localidad</th>
            <th scope="col" class="text-center">Estado</th>
            <th scope="col">Teléfono</th>
            <th scope="col" class="text-right">Monto</th>
            <th scope="col" class="text-right">Abono</th>
            <th scope="col" class="text-right">Saldo</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngIf="resumen_loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!resumen_loading && resumen_listaMovimientos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let mov of resumen_listaMovimientos">
            <td>{{mov.rutFormato | rut}}</td>
            <td>{{mov.razonSocialCliente}}</td>
            <td>{{mov.direccion_nombre}}</td>
            <td>{{mov.comuna_nombre}}</td>
            <td>{{mov.localidad}}</td>
            <td class="text-center">
              <div *ngIf="!mov.bloqueado">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="mov.bloqueado == true && mov.bloqueado_protesto == false">
                <mdb-badge pill="false" danger="true">Inactivo</mdb-badge>
              </div>
              <div *ngIf="mov.bloqueado_protesto == true">
                <mdb-badge pill="false" danger="true">Bloqueado</mdb-badge>
              </div>
            </td>
            <td>{{mov.telefono!= 0 ? mov.telefono : ""}}</td>
            <td class="text-right">{{mov.monto | numerico}}</td>
            <td class="text-right">{{mov.abono | numerico}}</td>
            <td class="text-right">{{mov.saldo | numerico }}</td>

          </tr>
        </tbody>

      </table>

      <div class="table-responsive" *ngIf="resumen_listaMovimientos?.length > 0">
        <table class="table table-striped table-hover table-sm align-middle">
          <tbody style="text-align:right;">
            <tr>
              <td class="col">
                <span style="font-weight: bold; font-size: 15px;">Total Monto: </span>
                <span>$ {{resumen_totales.total_monto | numerico}}</span>
              </td>
              <td class="col">
                <span style="font-weight: bold; font-size: 15px;">Total Pago: </span>
                <span>$ {{resumen_totales.total_pago | numerico}}</span>
              </td>
              <td class="col">
                <span style="font-weight: bold; font-size: 15px;">Total Saldo: </span>
                <span>$ {{resumen_totales.total_saldo | numerico}}</span>
              </td>
          </tbody>
        </table>
      </div>

      <app-pagination [context]="resumen_paginationContext" (onPageChange)="resumenOnPageChange($event)"
        *ngIf="resumen_listaMovimientos?.length > 0">
      </app-pagination>

    </div>
    <!-- INICIO DETALLE -->
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="detalle_listaMovimientos"
        id="DocxCobrar">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">RUT</th>
            <th scope="col">Nombre</th>
            <th scope="col">Tipo</th>
            <th scope="col">Nro.</th>
            <th scope="col">Fecha Doc.</th>
            <th scope="col">Fecha Venc.</th>
            <th scope="col">Dirección</th>
            <th scope="col">Comuna</th>
            <th scope="col">Localidad</th>
            <th scope="col">Estado</th>
            <th scope="col">Teléfono</th>
            <th scope="col">Vend. Cod.</th>
            <th scope="col">Vend. Nombre</th>
            <th scope="col">Monto</th>
            <th scope="col">Abono</th>
            <th scope="col">Saldo</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngIf="resumen_loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!resumen_loading && detalle_listaMovimientos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let mov of detalle_listaMovimientos">
            <td>{{mov.rutFormato | rut}}</td>
            <td>{{mov.razonSocialCliente}}</td>
            <td>{{mov.documento}}</td>
            <td>{{mov.folio}}</td>
            <td>{{mov.fecha_emision | fecha}}</td>
            <td>{{mov.fechaVencimientoDocto | fecha}}</td>
            <td>{{mov.direccion_nombre}}</td>
            <td>{{mov.comuna_nombre}}</td>
            <td>{{mov.localidad}}</td>
            <td class="text-center">
              <div *ngIf="!mov.bloqueado">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="mov.bloqueado == true && mov.bloqueado_protesto == false">
                <mdb-badge pill="false" danger="true">Inactivo</mdb-badge>
              </div>
              <div *ngIf="mov.bloqueado_protesto == true">
                <mdb-badge pill="false" danger="true">Bloqueado</mdb-badge>
              </div>
            </td>
            <td>{{mov.telefono!= 0 ? mov.telefono : ""}}</td>
            <td>{{mov.vendedor_codigo}}</td>
            <td>{{mov.vendedor_nombre}}</td>
            <td align="right">$ {{mov.monto | numerico}}</td>
            <td>$ {{mov.abono | numerico}}</td>
            <td>$ {{mov.saldo | numerico }}</td>

          </tr>
        </tbody>
      </table>

      <div class="table-responsive" *ngIf="detalle_listaMovimientos?.length > 0">
        <table class="table table-striped table-hover table-sm align-middle">
          <tbody style="text-align:right;">
            <tr>
              <td class="col">
                <span style="font-weight: bold; font-size: 15px;">Total Monto: </span>
                <span>$ {{detalle_totales.total_monto | numerico}}</span>
              </td>
              <td class="col">
                <span style="font-weight: bold; font-size: 15px;">Total Pago: </span>
                <span>$ {{detalle_totales.total_pago | numerico}}</span>
              </td>
              <td class="col">
                <span style="font-weight: bold; font-size: 15px;">Total Saldo: </span>
                <span>$ {{detalle_totales.total_saldo | numerico}}</span>
              </td>
          </tbody>
        </table>
      </div>

      <app-pagination [context]="detalle_paginationContext" (onPageChange)="detalleOnPageChange($event)"
        *ngIf="detalle_listaMovimientos?.length > 0">
      </app-pagination>
    </div>
  </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumen_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="resumenDownloadExcelPdf('XLS')">
      Excel
    </button>
    <!-- <button mdbBtn type="button" color="success" mdbWavesEffect (click)="DownloadPDF()">
          PDF
      </button> -->
  </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && detalle_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="detalleDownloadExcelPdf('XLS')">
      Excel
    </button>
    <!-- <button mdbBtn type="button" color="success" mdbWavesEffect (click)="DownloadPDF()">
          PDF
      </button> -->
  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaRegistros?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect (click)="resumenDownloadExcelPdf('XLS')">
      EXCEL
    </button>
    <!-- <button mdbBtn type="button" color="success" mdbWavesEffect (click)="DownloadPDF()">
          PDF
      </button> -->
  </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" (onSelectSingle)="onClienteSeleccionado($event)"
  queryType="CLIENTE_CON_DEUDA" (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>

<!-- MODAL seleccionarVendedor -->
<app-modal-seleccionar-vendedor [multiple]="false" queryType="ONLY_RUT"
  (onSelectSingle)="onVendedorSeleccionado($event)" (onNotFound)="onVendedorNoEncontrado()">
</app-modal-seleccionar-vendedor>

<!-- MODAL seleccionarDocumento -->
<app-modal-seleccion-documento-ajuste></app-modal-seleccion-documento-ajuste>